// Action types
export const RECEIVE_DATA = "RECEIVE_DATA";
export const CLEAR_DATA = "CLEAR_DATA";

// Action creators
export const receiveDataAction = (payload) => ({
  type: RECEIVE_DATA,
  payload, // { methodType, dataModel, data, from, createdAt }
});

export const clearDataAction = () => ({
  type: CLEAR_DATA,
});
